import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { AccountGroupService } from '@galaxy/account-group';
import { combineLatest, Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { getImageSrc } from '../../core/images';
import {
  ManageSubscriptionsService,
  SubscriptionLimit,
} from '../../subscription-tier/utils/manage-subscriptions.service';
import { AccountInfo, AccountLookupService } from '../account-lookup.service';
import { CourseParams } from '../home-page-cards/home-page-card-footer/home-page-card-footer.component';

const SNAPSHOT_SKU = 'ST';

@Component({
  selector: 'app-snapshot-report-component',
  templateUrl: './snapshot-report.component.html',
  styleUrls: ['./snapshot-report.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('collapsed <=> expanded', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [AccountLookupService, AccountGroupService],
  standalone: false,
})
export class SnapshotReportComponent implements OnInit {
  subscriptionLimits$: Observable<SubscriptionLimit>;
  getImageSrc = getImageSrc;
  learnMoreToggled = false;

  contentTitle$: Observable<string>;
  businesses$: Observable<AccountInfo[]>;
  userCanAccessBilling$: Observable<boolean>;

  courseParams: CourseParams = {
    text: 'HOME_PAGE.SNAPSHOT_REPORTS.ACADEMY_LINK_TITLE',
    url: 'https://academy.conquerlocal.com/course/acquiring-leads/?utm_source=pc-home-page',
    logo: '/images/icons/conquer-local.png',
  };

  manageAccountsPage = '/manage-accounts';

  queryParams = { account_filters: '{}' };

  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private readonly manageSubscriptionsService: ManageSubscriptionsService,
    private readonly accountLookupService: AccountLookupService,
    private readonly appConfigService: AppConfigService,
  ) {}

  ngOnInit(): void {
    this.subscriptionLimits$ = this.manageSubscriptionsService.getProductDetails(SNAPSHOT_SKU);

    this.businesses$ = this.accountLookupService.lookupAccountsWithoutSnapshots().pipe(publishReplay(1), refCount());

    this.contentTitle$ = combineLatest([this.subscriptionLimits$, this.businesses$]).pipe(
      map(([sl, businesses]) => {
        if (sl.currentValue < sl.limitMax) {
          if (businesses.length === 1) {
            return 'HOME_PAGE.SNAPSHOT_REPORTS.SUBTITLE_UNDER_LIMIT_SINGULAR';
          }
          return 'HOME_PAGE.SNAPSHOT_REPORTS.SUBTITLE_UNDER_LIMIT';
        }
        if (businesses.length === 1) {
          return 'HOME_PAGE.SNAPSHOT_REPORTS.SUBTITLE_SINGULAR';
        }
        return 'HOME_PAGE.SNAPSHOT_REPORTS.SUBTITLE';
      }),
    );

    this.userCanAccessBilling$ = this.appConfigService.config$.pipe(
      map((config) => {
        return config.userCanAccessBilling;
      }),
    );
  }

  handleLearnMoreToggleClicked(): void {
    this.learnMoreToggled = !this.learnMoreToggled;
  }
}
